// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Env from "../../core/Env.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Request from "../../core/Request.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";

function fromString(value) {
  switch (value) {
    case "boost" :
      return {
        TAG: "Ok",
        _0: "Boost"
      };
    case "company" :
      return {
        TAG: "Ok",
        _0: "Company"
      };
    case "standard" :
      return {
        TAG: "Ok",
        _0: "Standard"
      };
    case "warehouse" :
      return {
        TAG: "Ok",
        _0: "Warehouse"
      };
    default:
      return {
        TAG: "Error",
        _0: undefined
      };
  }
}

function toString(value) {
  switch (value) {
    case "Standard" :
      return "Standard";
    case "Company" :
      return "Company";
    case "Boost" :
      return "Boost";
    case "Warehouse" :
      return "Warehouse";
  }
}

let BillingPlanKind = {
  fromString: fromString,
  toString: toString
};

function fromString$1(status) {
  switch (status) {
    case "open" :
      return "Open";
    case "paid" :
      return "Paid";
    case "paid_via_credit_note" :
      return "PaidViaCreditNote";
    case "uncollectible" :
      return "Uncollectible";
    case "void" :
      return "Void";
    default:
      return;
  }
}

function toString$1(status) {
  switch (status) {
    case "Open" :
      return "Amount due";
    case "Paid" :
      return "Paid";
    case "PaidViaCreditNote" :
      return "Paid via credit note";
    case "Uncollectible" :
      return "Uncollectible";
    case "Void" :
      return "Credited balance";
  }
}

let InvoiceStatus = {
  fromString: fromString$1,
  toString: toString$1
};

function decodeInvoice(json) {
  let dict = Json.decodeDict(json);
  let match = Json.flatDecodeDictFieldString(dict, "id");
  let match$1 = Json.flatDecodeDictFieldString(dict, "number");
  let match$2 = Json.flatDecodeDictFieldFloat(dict, "total");
  let match$3 = Json.flatDecodeDictFieldString(dict, "status");
  let match$4 = Json.flatDecodeDictFieldString(dict, "paymentLink");
  let match$5 = Json.flatDecodeDictFieldString(dict, "pdfLink");
  let match$6 = Json.flatDecodeDictFieldFloat(dict, "date");
  if (match !== undefined && match$1 !== undefined && match$2 !== undefined && match$6 !== undefined) {
    return {
      id: match,
      number: match$1,
      total: match$2,
      status: match$3 !== undefined ? fromString$1(match$3) : undefined,
      paymentLink: match$4,
      pdfLink: match$5,
      date: new Date(match$6)
    };
  }
}

function decodeResult(json) {
  let resultItems = Json.decodeArray(json);
  if (resultItems !== undefined) {
    return Stdlib_Array.filterMap(resultItems, decodeInvoice);
  } else {
    return [];
  }
}

let endpoint = Env.gatewayUrl() + "/billing-account/invoices/";

function make(shopId) {
  return Future.mapOk(Request.make(endpoint + shopId, "GET", undefined, undefined, undefined), undefined, decodeResult);
}

let InvoicesRequest = {
  decodeInvoice: decodeInvoice,
  decodeResult: decodeResult,
  endpoint: endpoint,
  make: make
};

let invoicesRequest = make;

export {
  BillingPlanKind,
  InvoiceStatus,
  InvoicesRequest,
  invoicesRequest,
}
/* endpoint Not a pure module */
